import React, { useEffect } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import { updateList } from '~/Redux/Modules/UserLists';

const PinIcon = props => {
  const { list, dispatchUpdateList, className } = props;
  const clickhandler = e => {
    e.stopPropagation();
    e.preventDefault();
    if (list.pinned) {
      dispatchUpdateList({ ...list, pinned: false });
    } else {
      dispatchUpdateList({ ...list, pinned: true });
    }
  };

  const mouseHandler = e => {
    e.preventDefault();
    e.stopPropagation();
  };

  useEffect(() => {}, [list.pinned]);
  return (
    <div
      onClick={e => clickhandler(e)}
      onMouseDown={e => mouseHandler(e)}
      onMouseUp={e => mouseHandler(e)}
      role="button"
      tabIndex="0"
    >
      <svg
        className={cn(
          'pin-icon',
          'do-not-close-dropdown',
          className,
          list.pinned ? 'is-pinned' : null
        )}
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="16px"
        height="16px"
        viewBox="0 0 16 16"
        style={{ enableBackground: 'new 0 0 16 16' }}
        xmlSpace="preserve"
      >
        <title>Pin List</title>
        <g>
          <defs>
            <rect id="SVGID_1_" width="16" height="16" />
          </defs>
          <clipPath id="SVGID_00000162341548930806890980000000976956451504314774_">
            <use xlinkHref="#SVGID_1_" style={{ overflow: 'visible' }} />
          </clipPath>
          <g
            style={{ clipPath: 'url(#SVGID_00000162341548930806890980000000976956451504314774_)' }}
          >
            <path
              className="do-not-close-dropdown"
              d="M8,14.7c-0.4,0-0.7-0.3-0.7-0.7l0-4.7H4C3.6,9.3,3.3,9,3.3,8.7c0-0.2,0.1-0.4,0.2-0.5C3.6,8,3.7,8,3.9,7.9
			c0.9-0.2,1.5-1,1.5-1.9V2.7H4.7C4.3,2.7,4,2.4,4,2c0-0.4,0.3-0.7,0.7-0.7h6.7C11.7,1.3,12,1.6,12,2c0,0.4-0.3,0.7-0.7,0.7h-0.7V6
			c0,0.9,0.6,1.7,1.5,1.9c0.1,0,0.3,0.1,0.4,0.2l0.1,0.1l0,0.3c0,0.5-0.3,0.8-0.7,0.8H8.7l0,4.7C8.7,14.4,8.4,14.7,8,14.7z
			 M11.9,8.9C11.9,8.9,11.9,8.9,11.9,8.9C11.9,8.9,11.9,8.9,11.9,8.9z M4.1,8.9C4.1,8.9,4.1,8.9,4.1,8.9C4.1,8.9,4.1,8.9,4.1,8.9z
			 M6.3,2.3V6c0,0.9-0.4,1.8-1.1,2.3h5.6C10.1,7.8,9.7,6.9,9.7,6V2.3H6.3z"
            />
          </g>
        </g>
      </svg>
    </div>
  );
};

PinIcon.propTypes = {
  list: propTypes.object,
  dispatchUpdateList: propTypes.func,
  className: propTypes.string,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => {
  return {
    dispatchUpdateList: data => dispatch(updateList(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PinIcon);
